import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { POD_PRICE_ASSIGNMENT_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updatePodPriceAssignmentAction = createAsyncThunk(
    'price/updatePodPriceAssignmentAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(POD_PRICE_ASSIGNMENT_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updatePodPriceAssignmentSlice = createSlice({
    name: 'updatePodPriceAssignmentSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updatePodPriceAssignmentAction.pending, () => STATE__API__STARTED);
        builder.addCase(updatePodPriceAssignmentAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updatePodPriceAssignmentAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updatePodPriceAssignmentState = (state) => state.price.updatePodPriceAssignment;
export default updatePodPriceAssignmentSlice.reducer;
